import { timer, Subject } from 'rxjs';
import {
  mapTo,
  map,
  switchMap,
  takeUntil,
  tap,
  takeWhile,
} from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { Type } from './redux';
import { Type as SysType } from '../redux';
import { Type as LayoutType } from '../Layout/redux';

const pollingSubject = new Subject();

const getCheckinList = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.GET_CHECKIN_LIST),
    switchMap(() => {
      const {
        value: {
          mirroring: {
            checkin: { pageIndex, pageSize, signinStatus },
            ws: { socketData },
            layout,
          },
        },
      } = state$;
      return fetch({
        url:
          '/mm-classroom/web/j/mocSigninRpcBean.getUniversalSignDetaiRecord4Teacher.rpc',
        body: {
          signinId: socketData?.checkinDataTransportFromWl?.signId,
          signinStatus,
          pageIndex,
          pageSize,
          sort: 1,
          targetId: socketData?.checkinDataTransportFromWl?.classroomId,
        },
      });
    }),
    map(data => ({ type: Type.GET_CHECKIN_DATA_SUCCESS, data })),
  );
// 周期性的获得签到二维码
const getCheckinQrcodeUrl = (action$, state$, { fetch }) => {
  return action$.pipe(
    ofType(Type.GET_CHECKIN_QRCODE_URL),
    switchMap(() => {
      const {
        value: {
          mirroring: {
            ws: { socketData },
          },
        },
      } = state$;
      return fetch({
        url: '/mm-classroom/web/j/mocSigninRpcBean.getSignInQRCode.rpc',
        body: {
          signInId: socketData?.checkinDataTransportFromWl?.signId,
          width: 220,
          height: 220,
          duration: 6,
        },
      });
    }),
    map(data => {
      return { type: Type.GET_CHECKIN_QRCODE_URL_SUCCESS, data };
    }),
  );
};
const rejectSignLeavel = (action$, state$, { fetch }) => {
  return action$.pipe(
    ofType(Type.REJECT_SIGN_LEAVEL),
    switchMap(({ studentMemberId, refusalReason }) => {
      const {
        value: {
          mirroring: {
            ws: { socketData },
          },
        },
      } = state$;
      return fetch({
        url:
          '/mm-classroom/web/j/mocSigninRpcBean.refusalUniversalSignLeave.rpc',
        body: {
          signinId: socketData?.checkinDataTransportFromWl?.signId,
          studentMemberId,
          refusalReason,
        },
      });
    }),
    map(data => {
      return { type: Type.REJECT_SIGN_LEAVEL_SUCCESS, data };
    }),
  );
};
const checkinPolling = (action$, state$, { doc }) =>
  action$.pipe(
    ofType(Type.CHECKIN_POLLING),
    switchMap(() => timer(0, 3000)),
    tap(() => {
      const cookies = doc.cookie.split('; ').reduce((accu, item) => {
        if (item) {
          const [key, value] = item.split('=');
          if (key) {
            accu[key] = value;
          }
        }
        return accu;
      }, {});
      if (doc.getElementById('finishHidden')) {
        pollingSubject.next(true);
      }
      if (
        !state$.value.mirroring.ws.socketData?.checkinDataTransportFromWl
          ?.signId
      ) {
        pollingSubject.next(true);
      }
      // 代码太深奥了，这里serverTime，signClosedTime不知道为什么无法获取最新值，
      // 导致第二次打开签到时无法再重新轮询获取签到信息,所以还是按照以前的老代码，不检测签到是否关闭了，一直轮询吧
      // // 如果服务器时间大于签到关闭时间说明签到关闭了，取消签到信息获取
      // const { serverTime, signClosedTime } = state$.value.mirroring.checkin;
      // console.log(serverTime, signClosedTime);
      // if (serverTime > signClosedTime) {
      //   pollingSubject.next(true);
      // }
    }),
    takeUntil(pollingSubject.pipe(mapTo({ type: SysType.SWALLOW_IT }))),
    mapTo({ type: Type.GET_CHECKIN_LIST }),
  );

const tabChange = action$ =>
  action$.pipe(
    ofType(Type.CHECKIN_TAB_CHANGE),
    mapTo({ type: Type.GET_CHECKIN_LIST }),
  );

const checkinNext = action$ =>
  action$.pipe(
    ofType(Type.CHECKIN_NEXT),
    mapTo({ type: Type.GET_CHECKIN_LIST }),
  );

const closeCheckin = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.CLOSE_CHECKIN),
    switchMap(() => {
      const {
        value: {
          mirroring: {
            ws: { socketData },
            layout,
          },
        },
      } = state$;
      let classroomId = socketData?.checkinDataTransportFromWl?.classroomId;
      try {
        const urlParams = new URLSearchParams(location.search);
        classroomId = classroomId || urlParams.get('classroomId');
      } catch (error) {}
      return fetch({
        url:
          '/mm-classroom/web/j/mocSigninRpcBean.closeUniversalSigninAction.rpc',
        body: {
          classroomId,
          signinId: socketData?.checkinDataTransportFromWl?.signId,
        },
      });
    }),
    map(data => ({ type: Type.CLOSE_CHECKIN_SUCCESS, data })),
  );

const closeCheckinSuccess = action$ =>
  action$.pipe(
    ofType(Type.CLOSE_CHECKIN_SUCCESS),
    mapTo({ type: LayoutType.GET_CLASSROOM_LESSON_INFO }),
  );

const switchSignType = action$ => {
  return action$.pipe(
    ofType(Type.SWITCH_SIGN_TYPE),
    map(({ signType }) => {
      return {
        type: Type.SWITCH_SIGN_TYPE_SUCCESS,
        signType,
      };
    }),
  );
};

export default [
  getCheckinList,
  checkinPolling,
  tabChange,
  checkinNext,
  closeCheckin,
  closeCheckinSuccess,
  getCheckinQrcodeUrl,
  switchSignType,
  rejectSignLeavel,
];
